import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Modal = ({ isOpen, onClose, id = null }) => {
  const [formData, setFormData] = useState({
    job: '',
    experience: '',
    type: '',
    description: '',
    skills: '',
    qualification: '',
    location: '',
    id: '',
    image: '',
    additionalInfo: '',
  });

  const [imageFile, setImageFile] = useState(null); // New state to hold file

  useEffect(() => {
    if (isOpen && id) {
      const fetchData = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/careerPost/${id}`);
          setFormData(response.data);
        } catch (error) {
          console.error('Error fetching career data:', error);
        }
      };
      fetchData();
    }
  }, [isOpen, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();
      for (let key in formData) {
        form.append(key, formData[key]);
      }
      if (imageFile) {
        form.append('image', imageFile); // Important: field name must match multer's expected field
      }

      const response = await axios.put(`${process.env.REACT_APP_API_URL}/careerPost/${id}`, form);
      console.log('Career post updated:', response.data);
      onClose();
    } catch (error) {
      console.error('Update failed:', error);
    }
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 *:font-sans">
          <div className="fixed inset-0 bg-black opacity-50"></div>
          <div className="bg-white p-8 rounded-lg shadow-lg z-50 w-[90vw] sm:w-[80vw] max-h-[90vh] overflow-y-auto">
            <div className="flex mb-3 justify-between">
              <div className="font-semibold">Edit</div>
              <button onClick={onClose} className="text-black focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <form onSubmit={handleSubmit} encType="multipart/form-data" className="space-y-4">
              {/* First Row */}
              <div className="flex flex-wrap gap-4">
                {['job', 'experience', 'type'].map(field => (
                  <div key={field} className="flex flex-1 flex-col mx-2">
                    <label className="text-sm mb-1 capitalize">{field}</label>
                    <input type="text" name={field} value={formData[field]} onChange={handleChange}
                      className="border px-2 py-1 rounded-xl text-sm" />
                  </div>
                ))}
              </div>

              {/* Second Row */}
              <div className="flex flex-wrap gap-4">
                {['skills', 'qualification', 'location'].map(field => (
                  <div key={field} className="flex flex-1 flex-col mx-2">
                    <label className="text-sm mb-1 capitalize">{field}</label>
                    <input type="text" name={field} value={formData[field]} onChange={handleChange}
                      className="border px-2 py-1 rounded-xl text-sm" />
                  </div>
                ))}
              </div>

              {/* Third Row */}
              <div className="flex flex-wrap gap-4">
                <div className="flex flex-1 flex-col mx-2">
                  <label className="text-sm mb-1">Custom ID</label>
                  <input type="text" name="id" value={formData.id} onChange={handleChange}
                    className="border px-2 py-1 rounded-xl text-sm" />
                </div>
                <div className="flex flex-1 flex-col mx-2">
                  <label className="text-sm mb-1">Upload New Image</label>
                  <input type="file" name="image" accept="image/*" onChange={handleImageChange}
                    className="border px-2 py-1 rounded-xl text-sm" />
                  {formData.image && (
                    <img src={formData.image} alt="Preview" className="h-20 mt-2 object-contain rounded" />
                  )}
                </div>
              </div>

              {/* Description */}
              <div className="flex flex-col mx-2">
                <label className="text-sm mb-1">Description</label>
                <textarea name="description" value={formData.description} onChange={handleChange}
                  className="border px-2 py-2 rounded-xl text-sm h-[15vh]" />
              </div>

              {/* Additional Info */}
              <div className="flex flex-col mx-2">
                <label className="text-sm mb-1">Additional Info</label>
                <textarea name="additionalInfo" value={formData.additionalInfo} onChange={handleChange}
                  className="border px-2 py-2 rounded-xl text-sm h-[10vh]" />
              </div>

              <div className="text-center">
                <button type="submit"
                  className="bg-black text-white my-2 px-4 py-2 rounded-lg text-sm duration-300 hover:bg-[#919191]">
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
